import { getHistoryOrdersInfo } from 'api/historypage';
import { useAuthQuery } from 'hooks/useAuthQuery';

export const useOrderHistory = () => {
  const { isLoading, data } = useAuthQuery('orders', getHistoryOrdersInfo);

  return {
    isLoading,
    data,
  };
};
